module.exports = __webpack_public_path__ + "img/GreenLightGIFFAnimationv2.4f7d1396.gif";